function sdAppendScript(src) {
  var head = document.head;
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = src;
  head.appendChild(script);
}

const processConsent = () => {
  const vendorFns = {
    "68d148cd5a53919cdbb26cdd": "https://s3.tradingview.com/tv.js",
    "68af08bdbe434bed617e57ae": "https://211748.t.hyros.com/v1/lst/universal-script?ph=96d0dd903e2d4e2ff5487dd879e8b869988220978217b20d60e90c8de0c5a402&tag=!clicked&ref_url=" + encodeURI(document.URL),
    "68d14d6b4157a42d813e2a39": "https://assets.klicktipp.com/listbuildings/system/forms/scripts/protect.js",
    "5f85aa708057fa2a56e1a7c1": "https://d.finative.cloud/cds/delivery/init",
    // comes from wordpress-plugin
    // "68d146cc2b71fe68eef52fd0": "https://www.digistore24-scripts.com/service/digistore.js?ver=2.52wp",
    "68d14a6cb538c2058df897ef": "https://finanztrends.b-cdn.net/js/ep-sharedeals.js",
    "358": "https://jsc.mgid.com/site/1079213.js",
  }

  const onAcceptedConsent = (ven, name) => {
    if (!ven) {
      console.debug("Consent not given to unbeknown vendor: ", name);
      return;
    }
    switch (typeof ven) {
    case 'function':
      console.debug("Consent given for " + name + + ", inserting as fn");
      ven();
      break;
    case 'string':
      console.debug("Consent given for " + name + ", inserting as str");
      sdAppendScript(ven);
      break;
    default:
      console.error("Consent given for " + name + ", but cannot insert " + (typeof ven));
    }
  }

	// handle event from sourcepoint
  if (typeof(__tcfapi) == 'function') {
	  __tcfapi('addEventListener', 2, function(tcData, success) {
      if (success && (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete')) {
        // first, handle normal vendors (numeric ids)
        for (const [id, ven] of Object.entries(vendorFns)) {
          if (tcData.vendor.consents[id]) {
            onAcceptedConsent(ven, id);
          }
        };
        __tcfapi('getCustomVendorConsents', 2, (d) => {
          console.log("tcfapi custom vendors", d);
          d.consentedVendors.forEach((consented) => {
            const ven = vendorFns[consented._id];
            const name = consented.name;
            onAcceptedConsent(ven, name);
          });
        });
      }
	  });
  }
}

export default processConsent;
